export function analyticsDebugEnabled(){
    return !!localStorage.getItem('analyticsDebug')
}